import { render, staticRenderFns } from "./ManageClientDocuments.vue?vue&type=template&id=2de87e7a&"
import script from "./ManageClientDocuments.vue?vue&type=script&lang=js&"
export * from "./ManageClientDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports